import React, { useEffect } from "react";
import _noop from "lodash/noop";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import OrigRow from "react-bootstrap/Row";

import { useForm } from "react-hook-form";
import styled from "@emotion/styled";

import { Button } from "@/components/Buttons";
import Modal from "@/components/Modal";
import { useCsesStore, useModalStore, useLoadingStore } from "@/store/hooks";

const Row = styled(OrigRow)`
  padding: 10px 0;
`;

const Title = styled.h3``;

const EditCsAnswerModal = ({ cs, onUpdate = _noop }) => {
  const { ...actions } = useCsesStore();
  const { closeModal } = useModalStore();
  const { startLoading, finishLoading } = useLoadingStore();
  const { register, handleSubmit, reset } = useForm();

  function handleClose() {
    closeModal();
  }

  useEffect(() => {
    reset({
      answer: cs.answer,
    });
  }, []);

  const onSubmit = async ({ answer }) => {
    try {
      startLoading();

      await actions.updateAnswer(cs.id, { answer });

      onUpdate();
      closeModal();
    } catch (e) {
      window.alert(`답변 수정에 실패햇습니다. ${e.message}`);
    } finally {
      finishLoading();
    }
  };

  return (
    <Modal size="md">
      <Modal.Header>
        <Title>기사님 답변 수정</Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Form.Group>
                <Form.Control
                  as="textarea"
                  rows="3"
                  name="answer"
                  ref={register}
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group as={OrigRow}>
            <Col>
              <Button type="submit">수정</Button>{" "}
              <Button type="button" variant="secondary" onClick={handleClose}>
                닫기
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditCsAnswerModal;